// extracted by mini-css-extract-plugin
module.exports = {"body1":"styles_body1__Wfh8J","body2":"styles_body2__X_0Uv","capture1":"styles_capture1__eImUq","capture2":"styles_capture2__BSy_q"};